<template>
  <main class="password-create">
    <h1 class="password-create__title">Создание пароля</h1>
    <form
      class="password-create__form"
      v-on:submit.prevent="onSubmit"
    >
      <password-input
        v-model="password"
        label="Новый пароль"
        v-bind:input-errors="passwordInputErrors" />
      <password-input
        v-model="passwordConfirmation"
        label="Повторите пароль"
        v-bind:input-errors="confirmPasswordInputErrors" />
      <password-info />
      <button
        class="password-create__submit"
        type="submit"
      >ОТПРАВИТЬ</button>
    </form>
  </main>
</template>
<script>
import notifierMixin from '@/mixins/notifierMixin';
import PasswordInput from '@/components/PasswordInput.vue';
import PasswordInfo from '@/components/PasswordInfo.vue';
/**
 * @description Компонент сброса пароля.
 * @type {Vue}
 */
export default {
  components: { PasswordInput, PasswordInfo },
  computed: {
    /**
     * @description Адрес электронной почты.
     * @type {string}
     */
    email() {
      const indexSearchParams = this.to.indexOf('?');
      if (indexSearchParams !== -1) {
        const searchParams = this.to.slice(indexSearchParams);
        return (new URLSearchParams(searchParams)).get('email');
      }
      return '';
    },
    passwordInputErrors({ unprocessingCauses }) {
      return unprocessingCauses.password || [];
    },
    confirmPasswordInputErrors({ unprocessingCauses }) {
      return unprocessingCauses.confirm_password || [];
    },
  },
  data() {
    return {
      /**
       * @description Просмотр паролей.
       * @type {boolean[]}
       */
      showPassword: [false, false],
      /**
       * @description Новый пароль.
       * @type {string}
       */
      password: '',
      /**
       * @description Подтверждение пароля.
       * @type {string}
       */
      passwordConfirmation: '',
      /**
       * @description Причины невозможности обработки.
       * @type {any}
       */
      unprocessingCauses: {},
    };
  },
  methods: {
    onCompleted(message) {
      this.notifySuccess(
        `${message} Сейчас вы будете перенаправлены на страницу входа.`,
      );
      const toAuth = () => {
        const params = {
          initialEmail: this.email,
        };
        this.$router.push({ name: 'Auth', params });
      };
      setTimeout(toAuth, 3000);
    },
    onSubmit() {
      this.unprocessingCauses = {};
      if (this.password.length < 8) {
        this.$set(
          this.unprocessingCauses,
          'password',
          ['Минимальная длина: 8 символов '],
        );
        return;
      }
      if (this.passwordConfirmation !== this.password) {
        this.$set(
          this.unprocessingCauses,
          'confirm_password',
          ['Пароли должны совпадать'],
        );
        return;
      }
      this
        .$authGateway
        .resetPassword(this.to, this.password)
        .then((result) => {
          result.forEach(({ message }) => { this.onCompleted(message); });
          result.forEachLeft(({ causes = {}, message }) => {
            this.notifyFail(message);
            this.unprocessingCauses = causes;
          });
        });
    },
    toggle(index) {
      this.$set(this.showPassword, index, !this.showPassword[index]);
    },
  },
  mixins: [
    notifierMixin,
  ],
  name: 'ResetPassword',
  props: {
    to: {
      default: () => '',
      type: String,
    },
  },
};
</script>
<style lang="scss" scoped>
@use "@/scss/buttons";
.field {
  &__icon {
    background-position: center;
    background-image: url("@/assets/img/eye-closed.svg");
    width: 26px;
    height: 26px;
    cursor: pointer;
    &_active {
      background-image: url("@/assets/img/eye-open.svg");
    }
  }
}
.password-create {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 605px;
  width: 100%;
  margin: 0 auto;
  &__title {
    font-style: normal;
    font-weight: 600;
    font-size: 50px;
    line-height: 60px;
    margin: 0 auto 10px 0;
  }
  &__form {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  &__label {
    color: #90A0B7;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
  }
  &__input {
    display: flex;
    flex-direction: column;
    border-radius: 4px;
    border: 1px solid #C2CFE0;
    height: 57px;
    width: 100%;
    padding: 0 15px;
    color: #192A3E;
    opacity: 0.7;
    margin: 0 0 30px 0;
    &:focus {
      color: #192A3E;
      background-color: #fff;
      border: 2px solid #0489E0;
      outline: 0;
    }
    &:disabled {
      background-color: #fff;
    }
  }
  &__submit {
    @include buttons.btn-blue(280px, 70px, 20px);
    &:disabled {
      background-color: var(--unfocus-color);
    }
  }
}
@media screen and (max-width: 480px) {
  .password-create {
    &__title {
      font-size: 28px;
      line-height: 30px;
      margin: 0 auto 10px 0;
    }
  }
}
</style>
